































import Control from '@/components/estimates/common/controls/Control';
import {Component, Mixins} from 'vue-property-decorator';

@Component({
    watch: {filledValues: 'updateValue'},
})
export default class MultiTextControl extends Mixins<Control<string[]>>(Control) {
    protected filledValues: string[] = [];

    public created(): void {
        if (this.value === null) {
            return;
        }

        this.filledValues = this.value.map(value => value);
    }

    public input(key: number, value: string) {
        this.filledValues[key] = value;
    }

    protected addValue(): void {
        this.filledValues.push('');
    }

    protected getValue(): string[] {
        return this.filledValues.filter(value => value !== '');
    }

    protected removeText(key: number): void {
        this.filledValues.splice(key, 1);
    }
}
